import { WSList } from "@wingspanhq/fe-component-library";

import { AIValidationWidget } from "../../../../components/AIValidationWidget";
import { RequirementContextType } from "../../../../types";
import { WayfinderWidget } from "../../../../../../shared/components/WayfinderWidget";
import {
  ISharedFileRequestResponse,
  SharedFileRequestContextType,
  SharedFileRequestJobType
} from "@wingspanhq/shared-files/dist/lib/interfaces";
import { useSharedFileSettingsQuery } from "../../../../../../query/sharedFile/query/useSharedFileSettingsQuery";
import { WSQueries } from "../../../../../../query/WSQuery";
import { EmptyComponent } from "../../../../../../shared/components/EmptyComponent";
import { AssurelyWidget } from "../AssurelyWidget";

type Props = {
  sharedFileRequest: ISharedFileRequestResponse;
  contextType: RequirementContextType;
};

export const SharedFileInstructionsWidgetsContainer: React.FC<Props> = ({
  sharedFileRequest,
  contextType
}) => {
  const querySharedFilesSettings = useSharedFileSettingsQuery(
    sharedFileRequest.sharedFileRequestSettingsId!,
    {
      enabled: !!sharedFileRequest.sharedFileRequestSettingsId
    }
  );

  // Do not show any widgets for SharedFile requirement type if contextType is None
  if (sharedFileRequest.contextType === SharedFileRequestContextType.None) {
    return null;
  }

  return (
    <WSQueries
      queries={{
        querySharedFilesSettings
      }}
      renderErrors={EmptyComponent}
      renderLoader={EmptyComponent}
    >
      {({ querySharedFilesSettingsData: sharedFileRequestSettings }) => {
        // Filter out validation jobs from the shared file request
        const validationJobs =
          sharedFileRequestSettings.jobs?.filter(
            job => job.type === SharedFileRequestJobType.Validation
          ) || [];

        if (validationJobs?.length > 0) {
          return (
            <WSList gap="L">
              {contextType === RequirementContextType.Payer ? (
                <AssurelyWidget />
              ) : null}
              <AIValidationWidget
                contextType={contextType}
                validationItems={validationJobs}
              />
              {contextType === RequirementContextType.Payee ? (
                <WayfinderWidget />
              ) : null}
            </WSList>
          );
        }

        return null;
      }}
    </WSQueries>
  );
};
